import { useSvgContext } from '@automata/ui/src/Svg';

import { MenuOptions } from './components/LabwareMenu';
import { RunVisualizationData } from './types';
import LabwareView from './views/LabwareView';

export type Props = {
  runProgressData: RunVisualizationData;
  elapsedTimeSeconds?: number;
  menuOptions?: MenuOptions;
};

const Main = ({ runProgressData, elapsedTimeSeconds, menuOptions }: Props) => {
  const { height, width } = useSvgContext();

  const brushProportion = 0.175;

  const brushHeight = height * brushProportion;
  const viewHeight = height - brushHeight;

  return (
    <LabwareView
      runProgressData={runProgressData}
      height={height}
      width={width}
      brushHeight={brushHeight}
      viewHeight={viewHeight}
      elapsedTimeSeconds={elapsedTimeSeconds}
      menuOptions={menuOptions}
    />
  );
};

export default Main;
